import React from 'react';
import ActionsCreateDocxTemplate from './ActionsCreateDocxTemplate';

const ActionsCreateDocxTemplateV2 = (props) => (
  <ActionsCreateDocxTemplate {...props} variant="v2" />
);

export default React.memo(ActionsCreateDocxTemplateV2);
